import { render } from "./Projects.vue?vue&type=template&id=7fb68956&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=7fb68956&scoped=true&lang=css"

import exportComponent from "/home/tobi/Documents/workspace/ytobi.github.io-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb68956"]])

export default __exports__